import { render, staticRenderFns } from "./ProfileExtraDataCard.vue?vue&type=template&id=afea15e2&scoped=true&"
import script from "./ProfileExtraDataCard.vue?vue&type=script&lang=js&"
export * from "./ProfileExtraDataCard.vue?vue&type=script&lang=js&"
import style0 from "./ProfileExtraDataCard.vue?vue&type=style&index=0&id=afea15e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afea15e2",
  null
  
)

export default component.exports